import { ReactElement, useState } from "react";
import { FormField, TextInput, PasswordInput } from "@justworkshr/milo-form";

import type { FormFieldProps } from "@justworkshr/milo-form";
import type { TextInputProps } from "@justworkshr/milo-form";
import type { PasswordInputProps } from "@justworkshr/milo-form";
import type { RegistrationInputValidation } from "pages/register/types/userRegistrationForm";

import FieldValidationIndicator from "../fieldValidationIndicator/FieldValidationIndicator";

import styles from "./text-input-form-field.module.css";

const emptyInputErrorMessage = "You missed this one.";

const TextInputFormField = ({
  isRequired = false,
  isPasswordInput = false,
  formField,
  textInput,
  validation,
}: {
  isRequired?: boolean;
  isPasswordInput?: boolean;
  formField: Omit<FormFieldProps, "children" | "required">;
  textInput: Omit<TextInputProps | PasswordInputProps, "required">;
  validation?: RegistrationInputValidation;
}): ReactElement => {
  const [showEmptyErrorMessage, setShowEmptyErrorMessage] = useState(false);
  const [showValidations, setShowValidations] = useState(false);
  const InputComponent = isPasswordInput ? PasswordInput : TextInput;

  const onChange: TextInputProps["onChange"] = (e) => {
    setShowEmptyErrorMessage(false);
    setShowValidations(true);

    textInput.onChange?.(e);
  };
  const onBlur: TextInputProps["onBlur"] = (e) => {
    const isEmpty = !textInput.value;
    const isValid = !!validation?.isValid;

    setShowEmptyErrorMessage(isEmpty && isRequired);
    setShowValidations(!isEmpty && !isValid);
    textInput.onBlur?.(e);
  };

  return (
    <FormField
      {...formField}
      required={isRequired}
      error={showEmptyErrorMessage ? emptyInputErrorMessage : formField.error}
    >
      <>
        <InputComponent
          {...textInput}
          required={isRequired}
          onBlur={onBlur}
          onChange={onChange}
        />

        {showValidations && validation && (
          <div className={styles.validations}>
            <FieldValidationIndicator
              validationCriteria={validation.validations}
            />
          </div>
        )}
      </>
    </FormField>
  );
};

export default TextInputFormField;
